import React, { useEffect, useState } from "react";
import { Header } from "../../../components/header/Header";

import { Link, useNavigate } from "react-router-dom";
import { createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import {
  resetContestThunk as onResetContest,
  getAllContestThunk as onGetAllContestThunk,
  createParticipateContestThunk as onCreateParticipateContestThunk,
} from "../../../slices/contest/thunk";
import { getRole } from "../../../utils/GetRole";
import { getAuthUser, getFileUrl } from "../../../utils/GetAuthUser";
import toast from "react-hot-toast";

import ArtistComponent from "../../dashboard-components/ArtistComponent";
import ArtistParticipateContestComponent from "../../dashboard-components/ArtistParticipateContestComponent";
import { checkUserType } from "../../../utils/GetAuthUser";

export const ArtistHome = () => {
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const statusCode = 140;
  const fileUrl = getFileUrl();
  const defaultImage = "/default.png";
  const [role, setRole] = useState(getRole());
    const userType =checkUserType();



  const authUser = getAuthUser();
  const [isContestCreated, setIsContestCreated] = useState(false);
 

  const selectPlansState = (state) => state.contest;

  const contestSelector = createSelector(selectPlansState, (contest) => ({
    isLoading: contest.isLoading,
    contestList: contest.contestList,
    isCreateContest: contest.isCreateContest,
  }));

  const { contestList, isCreateContest, isLoading } = useSelector(contestSelector);

  useEffect(() => {
    dispatch(onResetContest());
    const contestData = {
      statusCode: statusCode,
      checkParticipatArtistId:authUser ? authUser.user.id : null,
      limit:5,
    };

    dispatch(onGetAllContestThunk(contestData));
  }, [dispatch, statusCode]);

 const handleParticipate = async (contestId) => {
  dispatch(onResetContest());
  try {
    await dispatch(
      onCreateParticipateContestThunk({
        contestId: contestId,
        artistId: authUser ? authUser.user.id : null,
        is_accept: 1,
      })
    ).unwrap();
    
    // Reload after successful response
    // window.location.reload();
     const contestData = {
      statusCode: statusCode,
      checkParticipatArtistId:authUser ? authUser.user.id : null,
      limit:5,
    };

    dispatch(onGetAllContestThunk(contestData));
  } catch (error) {
    console.error('Failed to participate:', error);
  }
};

  const handleNavigateToSketchDetail = (contestId) => {
    navigate(`/${role}/contest-detail/2/${contestId}`);
  };

  useEffect(() => {
    if (isCreateContest) {
      setIsContestCreated(true);
    }
  }, [isCreateContest]);

  useEffect(() => {
    if (!isContestCreated) return;
    toast.success("Contest created successfully");
    const contestData = {
      statusCode,
   
    };

    dispatch(onResetContest());
    dispatch(onGetAllContestThunk(contestData));

    setIsContestCreated(false);
  }, [isContestCreated, dispatch, statusCode]);


  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
        {/* Header */}
        <Header name={"Sanan"} />
      </header>

      <div className="w-full  mx-auto bg-[#F7F7F7]">
        <div className="flex items-center justify-between mt-2">
          <div>
            <span className="text-[22px] text-black font-bold font-grotesk">
              New Contests
            </span>
          </div>
          <div>
            <Link
              to={`/artist/contests/140`}
              className="border border-border_color rounded-[10px] py-2 px-5 text-xs font-bold font-grotesk text-secondary"
            >
              View all
            </Link>
          </div>
        </div>
        {/* Items */}

        <div className="w-full mt-6">
          <div className="w-full mx-auto grid gap-3 sm:gap-4 grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
            {isLoading ? (
              Array.from({ length: 10 }).map((_, idx) => (
                <div key={idx} className="w-full flex flex-col justify-between relative h-full p-3 border border-border_color rounded-xl animate-pulse bg-white">
                  <div className="w-full h-[175px] rounded-xl overflow-hidden bg-gray-200" />
                  <span className="absolute top-4 right-4 w-20 h-6 bg-gray-200 rounded-full" />
                  <div className="flex flex-col justify-between flex-1 mt-3">
                    <div>
                      <div className="flex items-center justify-between mb-3">
                        <div className="w-[130px] h-8 rounded-3xl bg-gray-200" />
                      </div>
                      <div className="space-y-2">
                        <div className="h-4 bg-gray-200 rounded" />
                        <div className="h-4 bg-gray-200 rounded w-5/6" />
                      </div>
                    </div>
                    <div className="flex items-center justify-center gap-2 w-full mt-4">
                      <div className="h-10 bg-gray-200 rounded-[10px] w-full" />
                    </div>
                  </div>
                </div>
              ))
            ) : contestList && contestList.length > 0 ? (
              contestList.map((card) => {
                const contestImage = card.contestImage
                  ? `${fileUrl}${card.contestImage}`
                  : defaultImage;

                return (
                  <div
                    key={card.id}
                    className="w-full flex flex-col justify-between h-full p-3 border border-border_color rounded-xl relative"
                  >
                    {/* Contest Image */}
                    <div className="w-full h-[175px]">
                      <Link
                        href="#"
                        className="relative h-[175px] rounded overflow-hidden block"
                      >
                        <img
                          alt={card.title || "contest image"}
                          className="object-cover object-center w-full h-full block rounded-xl"
                          src={contestImage}
                          onError={(e) => (e.currentTarget.src = defaultImage)}
                        />
                      </Link>
                    </div>

                    <div className="flex flex-col justify-between flex-1 mt-3">
                      <div>
                        {/* Category */}
                        <div className="flex items-center justify-center border border-[#DDDDDD] py-[6px] px-[14px] w-[130px] rounded-3xl">
                          <span className="font-bold text-[11px] text-[#262626] font-grotesk">
                            {card.title || card.contestCategory}
                          </span>
                        </div>

                        {/* Description */}
                        <div className="mt-2">
                          <p className="text-[#696565] text-sm font-grotesk font-medium line-clamp-2">
                            {card.description || card.contestDescription}
                          </p>
                        </div>
                      </div>
                      {/* User Info */}
                      {/* <div className="flex items-center gap-2 mt-3">
                        <span className="text-sm font-medium text-[#262626]">
                          {card.userName}
                        </span>
                      </div> */}

                      <div className="flex items-center justify-center gap-2 w-full mt-2 flex-wrap">
                        {statusCode == 0 || statusCode == 140 ? (
                          <button
                            className="w-full flex flex-1 items-center justify-center text-xs font-bold border border-border_color font-grotesk text-primary py-3 px-5 rounded-[10px] whitespace-nowrap tracking-wide hover:text-white hover:bg-primary transition-all delay-75"
                            onClick={() =>
                              handleNavigateToSketchDetail(card.id)
                            }
                          >
                            View Details
                          </button>
                        ) : null}

                        {card.isAllowParticipate == 1 && (
                          <button
                            className="w-full flex flex-1 items-center justify-center text-xs tracking-wide font-bold text-white font-grotesk bg-primary py-3 px-5 rounded-[10px] whitespace-nowrap"
                            onClick={() => handleParticipate(card.id)}
                          >
                            Participate
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="text-center text-gray-500">No contests found</p>
            )}
          </div>
        </div>
        {/* Table */}
        <div className="w-full flex items-start justify-between flex-col xl:flex-row mt-8 gap-5">
          {/* Right */}
          <ArtistParticipateContestComponent artistId={authUser.user.id} />
          {/* Artist */}
          <ArtistComponent />
        </div>
      </div>
    </>
  );
};
